import { render, staticRenderFns } from "./agentChat.vue?vue&type=template&id=a8ab725c&"
import script from "./agentChat.vue?vue&type=script&lang=js&"
export * from "./agentChat.vue?vue&type=script&lang=js&"
import style0 from "./agentChat.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports